var d = new Date();  
function addBusinessDays(d,n) {
    var options = { weekday: 'long', month: 'long', day: 'numeric' };
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
  
    return d.toLocaleDateString("en-US", options);
}
    
const earliest_express = addBusinessDays(d,4);  
const express_ship = addBusinessDays(d,6);
  
const earliest_standard = addBusinessDays(d,4);    
const standard_ship = addBusinessDays(d,8); 
  
document.querySelector('.earliest_standard').innerHTML = earliest_standard;
document.querySelector('.standard_ship').innerHTML = standard_ship;
  
document.querySelector('.earliest_express').innerHTML = earliest_express;
document.querySelector('.express_ship').innerHTML = express_ship;  